import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@common/components/";
import { useSkuAddToListContext } from "./SkuAddToListContext";

/**
 * Input - SKU 輸入框子組件（非受控，用 key 清空）
 */
const Input = ({ placeholder = "請掃描或輸入商品SKU", className = "", ...otherProps }) => {
	const { inputKey, handleSubmit, isAdding, inputRef } = useSkuAddToListContext();

	return (
		<TextField
			key={inputKey}
			ref={inputRef}
			className={`input ${className}`}
			defaultValue=""
			onKeyPress={(e) => {
				if (e.key === "Enter") {
					e.preventDefault();
					handleSubmit();
				}
			}}
			placeholder={placeholder}
			autoFocus
			disabled={isAdding}
			fullWidth
			{...otherProps}
		/>
	);
};

Input.displayName = "SkuAddToList.Input";

Input.propTypes = {
	placeholder: PropTypes.string,
	className: PropTypes.string,
};

export default Input;
